export default __webpack_public_path__ + "static/media/twitter.b388329b.svg";